import { ITeam } from '@common/interfaces/team'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

// The admin list. Mutations flip isSaving; the page refetches on their success
// rather than folding rows in here, so the roster always comes from the server
// (mirrors customFields).
const teamsData = createLoadingDataReducer<ITeam[] | null>(
  [actions.LIST_TEAMS_REQUEST],
  [
    actions.CREATE_TEAM_REQUEST,
    actions.UPDATE_TEAM_REQUEST,
    actions.DELETE_TEAM_REQUEST,
    actions.SET_USER_TEAMS_REQUEST,
  ],
)

export default combineReducers({
  teamsData,
})
